import React from 'react';
import { Link } from 'react-router-dom';

function LinkWithTop({ to, onClick, ...rest }) {
    const handleClick = (e) => {
        if (onClick) {
            onClick(e);
        }
        window.scroll({
            top: 0,
            left: 0,
            behavior: "smooth",
        });
    };

    return <Link to={to} {...rest} onClick={handleClick} />;
}

export default LinkWithTop;
